/* eslint-disable no-unused-vars */
import { useCallback } from 'react';

function isValidFullUrl(url) {
  try {
    const parsed = new URL(url);
    const isHttp = parsed.protocol === 'http:' || parsed.protocol === 'https:';
    const hostname = parsed.hostname;
    const isValidHostname = /^[a-zA-Z0-9.-]+$/.test(hostname) || /^[0-9.]+$/.test(hostname);
    return isHttp && isValidHostname;
  } catch (e) {
    return false;
  }
}

export const useFacade = () => {
  const createUrlObj = useCallback((postBackUrl, defaultFields = []) => {
    const defaultFieldsSet = new Set(defaultFields);
    try {
      const url = new URL(postBackUrl);
      const urlData = {
        baseUrl: url.origin + url.pathname,
      };
      for (const field of defaultFields) {
        urlData[field] = '';
      }
      const params = new URLSearchParams(url.search);
      for (const [key, value] of params.entries()) {
        if (defaultFieldsSet.has(value)) {
          urlData[value] = key;
        } else {
          const separator = urlData.baseUrl.includes('?') ? '&' : '?';
          urlData.baseUrl = `${urlData.baseUrl}${separator}${key}=${value}`;
        }
      }
      return urlData;
    } catch (err) {
      return '';
    }
  }, []);

  const createPreview = useCallback((values) => {
    const obj = structuredClone(values);
    delete obj.state;
    let res = obj.baseUrl ? `${obj.baseUrl}?` : '';
    delete obj.baseUrl;
    for (let key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] === '') {
        delete obj[key];
      } else {
        res = res.concat(`&${obj[key]}`, '=', key);
      }
    }
    const index = res.indexOf('&');
    res = res.substring(0, index) + res.substring(index + 1);
    return res;
  }, []);

  const createPreview2 = useCallback((values) => {
    const { baseUrl, state, ...params } = structuredClone(values);
    if (isValidFullUrl(baseUrl)) {
      try {
        const url = new URL(baseUrl);
        const searchParams = url.searchParams;
        Object.entries(params).forEach(([key, value]) => {
          if (value !== '') {
            searchParams.append(value, key);
          }
        });
        const res = decodeURIComponent(url.href.toString());
        return res;
      } catch (e) {
        return '';
      }
    } else {
      return '';
    }
  }, []);

  return [createUrlObj, createPreview, createPreview2];
};
